import { useTranslation } from "react-i18next";
import DiscussionIcon from "src/images/Icons/newIcons/exam/options/discussion.svg";

import DefaultOptions from "./DefaultOption";

export default function Discussion({ details, settings, actions, dispatch }) {
	const { t } = useTranslation();
	const discussionCount =
		(details.hasDiscussion ? 1 : 0) + (details.hasAiDiscussion ? 1 : 0);
	const discussionExist = discussionCount > 0;

	const getSubText = () => {
		if (details.hasDiscussion && details.hasAiDiscussion)
			return t("exam.discussionSubText", "Autor + AI");
		if (details.hasAiDiscussion) return t("exam.discussionSubTextAi", "AI");
		if (details.hasDiscussion)
			return t("exam.discussionSubTextAuthor", "Autor");
		return undefined;
	};

	return (
		<DefaultOptions
			keysToPress={["Meta + o"]}
			dispatch={dispatch}
			optionKey="discussion"
			Icon={<DiscussionIcon className="icon-normal" />}
			text={t("exam.discussion")}
			subText={getSubText()}
			action={actions.toggleSettings}
			settings={settings}
			disabled={!details.visibility?.discussion}
			details={details}
			badgeOptions={{
				badgeContent: discussionCount,
				color: "secondary",
				hidden: !discussionExist,
			}}
		/>
	);
}
